import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import DashboardTemplate from "../../Common/DashboardTemplate";
import {CircularProgress} from "@material-ui/core";
import axios from 'axios';
import {ServiceLocator} from "../../../Services/ServiceLocator";
import DrawerMenuRight from "../../Common/DrawerMenuRight";
import {Button} from "@material-ui/core";
import { v4 as uuid } from 'uuid';
import Papa from "papaparse";

import { AuthenticationService } from "../../../Services/AuthenticationService";
const styles = theme => ({
    wrapper: {
        margin: -5,
    },
});

let assemblies;
let subAssemblies;
let parts;

class AdminImportUtilities extends React.Component {
    state = {
        loading: true,
        user: {},
        users: []
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const self = this;
        const user = AuthenticationService.getInstance().getUser();
        if (!user || !user.userPermissions || !user.userPermissions.includes('Purchase')) {
            globalProps.history.push('/login');
            return;
        }

        self.setState({loading: true});
        Promise.all([self.loadAssemblies(), self.loadSubAssemblies(), self.loadParts(), self.loadSalesLogs()]).then(() => {
            self.setState({loading: false, parts, assemblies, subAssemblies, user, permissions: user.userPermissions});
        });
    };

    loadAssemblies = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllAssembliesExpanded().then((assembliesResult) => {
            assemblies = assembliesResult;
        });
    };

    loadSubAssemblies = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllSubAssembliesExpanded().then((subAssembliesResult) => {
            subAssemblies = subAssembliesResult;
            self.setState({subAssemblies});
        });
    };

    loadParts = () => {
        const self = this;
        self.setState({loading: true});
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getAllPartsExpanded().then((partsResult) => {
            parts = partsResult;
        });
    };

    loadSalesLogs = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getSalesLogs().then((salesLogsResult) => {
            self.setState({salesLogs: salesLogsResult});
        });
    };

    importParts = () => {
        const self = this;
        let {importedPartsData} = self.state;
        if (!importedPartsData) return window.$alertWarning("You must upload a .csv file to import.");

        const partTypes = ["Driveshaft Carriers", "Center Support Bearing Spacers", "Hardware", "Oils and Additives", "Bushings", "Tools", "Toolbox Organizer (VersaTool)", "SPC Products", "Racing", "Labor", "Packaging", "Clutches and Flywheels", "Slave Cylinders", "Per4mance Development", "Autotech", "034 Motorsport", "Bushing Inserts", "Differential Braces", "Differentials", "Spherical Adapters", "Spherical Bearings", "Spherical Cores", "External Retaining Rings", "Internal Retaining Rings", "Control Arms", "Misc Suspension", "Aston Martin Miscellaneous", "Audi B8 Miscellaneous", "Audi C7 Miscellaneous", "Axles", "Wheel Spacers", "Apparel", "Other People's Parts"];

        self.setState({savingImportedData: true});
        let importedRows = [];

        importedPartsData = importedPartsData.slice(1);
        importedPartsData.forEach((importedRow) => {
            // Skip rows where the first three columns (primary, secondary, tertiary part types) are blank
            if (!importedRow[0] && !importedRow[1] && !importedRow[2]) {
                return;
            }

            if (importedRow[25]) { // Adjusted index: was [22], now [25] (22+3)
                const partId = uuid();
                let tieredCostFormulas = [];
                if (importedRow[6] === 'Tiered' && importedRow[9] && importedRow[9].trim() !== '') { // Adjusted indices
                    if (importedRow[8] !== '' && importedRow[9] !== '') { // Adjusted indices: was [5,6], now [8,9]
                        tieredCostFormulas.push({
                            id: uuid(),
                            partFk: partId,
                            isSelected: importedRow[7] === 'x', // Adjusted index: was [4], now [7]
                            price: (() => {
                                const parsed = Number.parseFloat(importedRow[9].trim().replace('$', ''));
                                return isNaN(parsed) ? 0.00 : parsed;
                            })(),
                            quantity: importedRow[8]
                        });
                    }
                    if (importedRow[11] !== '' && importedRow[12] !== '') { // Adjusted indices: was [8,9], now [11,12]
                        tieredCostFormulas.push({
                            id: uuid(),
                            partFk: partId,
                            isSelected: importedRow[10] === 'x', // Adjusted index: was [7], now [10]
                            price: (() => {
                                const parsed = Number.parseFloat(importedRow[12].trim().replace('$', ''));
                                return isNaN(parsed) ? 0.00 : parsed;
                            })(),
                            quantity: importedRow[11]
                        });
                    }
                    if (importedRow[14] !== '' && importedRow[15] !== '') { // Adjusted indices: was [11,12], now [14,15]
                        tieredCostFormulas.push({
                            id: uuid(),
                            partFk: partId,
                            isSelected: importedRow[13] === 'x', // Adjusted index: was [10], now [13]
                            price: (() => {
                                const parsed = Number.parseFloat(importedRow[15].trim().replace('$', ''));
                                return isNaN(parsed) ? 0.00 : parsed;
                            })(),
                            quantity: importedRow[14]
                        });
                    }
                    if (importedRow[17] !== '' && importedRow[18] !== '') { // Adjusted indices: was [14,15], now [17,18]
                        tieredCostFormulas.push({
                            id: uuid(),
                            partFk: partId,
                            isSelected: importedRow[16] === 'x', // Adjusted index: was [13], now [16]
                            price: (() => {
                                const parsed = Number.parseFloat(importedRow[18].trim().replace('$', ''));
                                return isNaN(parsed) ? 0.00 : parsed;
                            })(),
                            quantity: importedRow[17]
                        });
                    }
                    if (importedRow[20] !== '' && importedRow[21] !== '') { // Adjusted indices: was [17,18], now [20,21]
                        tieredCostFormulas.push({
                            id: uuid(),
                            partFk: partId,
                            isSelected: importedRow[19] === 'x', // Adjusted index: was [16], now [19]
                            price: (() => {
                                const parsed = Number.parseFloat(importedRow[21].trim().replace('$', ''));
                                return isNaN(parsed) ? 0.00 : parsed;
                            })(),
                            quantity: importedRow[20]
                        });
                    }
                    if (importedRow[23] !== '' && importedRow[24] !== '') { // Adjusted indices: was [20,21], now [23,24]
                        tieredCostFormulas.push({
                            id: uuid(),
                            partFk: partId,
                            isSelected: importedRow[22] === 'x', // Adjusted index: was [19], now [22]
                            price: (() => {
                                const parsed = Number.parseFloat(importedRow[24].trim().replace('$', ''));
                                return isNaN(parsed) ? 0.00 : parsed;
                            })(),
                            quantity: importedRow[23]
                        });
                    }
                    if (importedRow[26] !== '' && importedRow[27] !== '') { // Formula 7
                        tieredCostFormulas.push({
                            id: uuid(),
                            partFk: partId,
                            isSelected: importedRow[25] === 'x',
                            price: (() => {
                                const parsed = Number.parseFloat(importedRow[27].trim().replace('$', ''));
                                return isNaN(parsed) ? 0.00 : parsed;
                            })(),
                            quantity: importedRow[26]
                        });
                    }
                    if (importedRow[29] !== '' && importedRow[30] !== '') { // Formula 8
                        tieredCostFormulas.push({
                            id: uuid(),
                            partFk: partId,
                            isSelected: importedRow[28] === 'x',
                            price: (() => {
                                const parsed = Number.parseFloat(importedRow[30].trim().replace('$', ''));
                                return isNaN(parsed) ? 0.00 : parsed;
                            })(),
                            quantity: importedRow[29]
                        });
                    }
                    if (importedRow[32] !== '' && importedRow[33] !== '') { // Formula 9
                        tieredCostFormulas.push({
                            id: uuid(),
                            partFk: partId,
                            isSelected: importedRow[31] === 'x',
                            price: (() => {
                                const parsed = Number.parseFloat(importedRow[33].trim().replace('$', ''));
                                return isNaN(parsed) ? 0.00 : parsed;
                            })(),
                            quantity: importedRow[32]
                        });
                    }
                    if (importedRow[35] !== '' && importedRow[36] !== '') { // Formula 10
                        tieredCostFormulas.push({
                            id: uuid(),
                            partFk: partId,
                            isSelected: importedRow[34] === 'x',
                            price: (() => {
                                const parsed = Number.parseFloat(importedRow[36].trim().replace('$', ''));
                                return isNaN(parsed) ? 0.00 : parsed;
                            })(),
                            quantity: importedRow[35]
                        });
                    }
                }

                // Create vendor parts structure with "Unknown" vendor
                const vendorParts = [{
                    id: uuid(),
                    partFk: partId,
                    vendorName: "Unknown",
                    vendorPartNumber: importedRow[3], // Adjusted index: was [0], now [3]
                    cost: importedRow[37] ? Number.parseFloat(importedRow[37].trim().replace('$', '')) : 0, // Adjusted index: was [25], now [37]
                    leadTimeInWeeks: importedRow[40] && importedRow[40].trim() !== '' ? importedRow[40] : 0, // Adjusted index: was [28], now [40]
                    isPreferred: true,
                    tieredCostFormulas: tieredCostFormulas
                }];

                const importedPayload = {
                    id: partId,
                    partType: importedRow[0],
                    manufacturerFor: importedRow[1],
                    tertiaryType: importedRow[2],
                    partId: importedRow[3], // Adjusted index: was [0], now [3]
                    revision: '0',
                    revisionNotes: '',
                    description: importedRow[4], // Adjusted index: was [1], now [4]
                    imageURL: importedRow[5], // Adjusted index: was [2], now [5]
                    costType: importedRow[6] === 'Tiered' ? 0 : 1, // Adjusted index: was [3], now [6]
                    basePrice: importedRow[37] ? Number.parseFloat(importedRow[37].trim().replace('$', '')) : 0, // Adjusted index: was [25], now [37]
                    msrp: 0,
                    quantity: importedRow[38] && importedRow[38].trim() !== '' ? importedRow[38] : 0, // Adjusted index: was [26], now [38]
                    leadTimeInWeeks: importedRow[40] && importedRow[40].trim() !== '' ? importedRow[40] : 0, // Adjusted index: was [28], now [40]
                    inventoryStrategy: 'A',
                    inventoryCorrection: importedRow[43] && importedRow[43].trim() !== '' ? importedRow[43] : 0, // Adjusted index: was [31], now [43]
                    vendorParts: vendorParts,
                    isActive: true
                };
                if (importedPayload.basePrice.toString() === 'NaN') importedPayload.basePrice = 0;

                importedRows.push(importedPayload);
            }
        });

        let confirm= window.confirm(`Are you sure you want to import ${importedRows.length} parts?`);

        if (confirm) {
            const partService = ServiceLocator.Instance.getPartService();
            partService.importParts(importedRows).then(() => {
                window.$alertSuccess("Parts imported");
                self.setState({importPartsOpen: false, savingImportedData: false});
                self.loadData();
            });
        } else {
            self.setState({savingImportedData: false});
        }
    };

    importAssemblies = () => {
        const self = this;
        let {importedAssembliesData} = self.state;
        if (!importedAssembliesData) return window.$alertWarning("You must upload a .csv file to import.");

        self.setState({savingImportedData: true});
        let importedAssemblies = [];
        let importedSubAssemblies = [];

        importedAssembliesData = importedAssembliesData.slice(1);
        importedAssembliesData.forEach((importedRow) => {
            // Skip rows where all three new type columns are blank
            if (!importedRow[0] && !importedRow[1] && !importedRow[2]) {
                return;
            }

            if (importedRow[19]) { // Adjusted index: was [16], now [19] (16+3)
                const assemblyId = uuid();

                if (importedRow[6] === 'x') {
                    let shippingCost = 0;
                    if (importedRow[10] && importedRow[10].trim()) { // Adjusted index: was [7], now [10] (7+3)
                        if (importedRow[10].indexOf('(') > -1)
                            shippingCost = Number.parseFloat(importedRow[10].replace('$', '').replace('(', '').replace(')', '')) * -1;
                        else
                            shippingCost = Number.parseFloat(importedRow[10].replace('$', ''));
                    }

                    const importedPayload = {
                        id: assemblyId,
                        assemblyFamilyId: null,
                        assemblyType: importedRow[0],
                        manufacturerFor: importedRow[1],
                        tertiaryType: importedRow[2],
                        assemblyId: importedRow[3], // Adjusted index: was [0], now [3]
                        revision: importedRow[4], // Adjusted index: was [1], now [4]
                        revisionNotes: '',
                        description: importedRow[7], // Adjusted index: was [4], now [7]
                        imageURL: importedRow[9], // Adjusted index: was [6], now [9]
                        squarespaceURL: importedRow[8], // Adjusted index: was [5], now [8]
                        shippingCost: shippingCost,
                        msrp: importedRow[11] && importedRow[11].trim() !== '' ? Number.parseFloat(importedRow[11].replace('$', '')) : 0, // Adjusted index: was [8], now [11]
                        discountTier1: importedRow[12] && importedRow[12].trim() !== '' ? Number.parseFloat(importedRow[12].replace('%', '')) / 100 : 0, // Adjusted index: was [9], now [12]
                        discountTier2: importedRow[14] && importedRow[14].trim() !== '' ? Number.parseFloat(importedRow[14].replace('%', '')) / 100 : 0, // Adjusted index: was [11], now [14]
                        discountTier3: importedRow[16] && importedRow[16].trim() !== '' ? Number.parseFloat(importedRow[16].replace('%', '')) / 100 : 0, // Adjusted index: was [13], now [16]
                        partsToAssemblies: [],
                        subAssembliesToAssemblies: [],
                        installVideoURL: '',
                        labelDescription: '',
                        weightPounds: 0,
                        weightOunces: 0,
                        spareBushingsSetId: null,
                        spareBushingsSetQuantity: 0,
                        spareHardwareSetId: null,
                        spareHardwareSetQuantity: 0,
                        isActive: true,
                        currentlyPackaging: true,
                        finalOrderNumber: null,
                        assemblyFamilyOrder: null,
                        effectiveDate: null
                    };

                    importedAssemblies.push(importedPayload);
                } else {
                    const importedPayload = {
                        id: assemblyId,
                        assemblyType: importedRow[0],
                        manufacturerFor: importedRow[1],
                        tertiaryType: importedRow[2],
                        subAssemblyId: importedRow[3], // Adjusted index: was [0], now [3]
                        revision: importedRow[4], // Adjusted index: was [1], now [4]
                        revisionNotes: '',
                        description: importedRow[7], // Adjusted index: was [4], now [7]
                        imageURL: importedRow[9], // Adjusted index: was [6], now [9]
                        partsToSubAssemblies: [],
                        isActive: true,
                        effectiveDate: null,
                        currentlyPackaging: true,
                        childSubAssemblies: [],
                        parentSubAssemblies: []
                    };

                    importedSubAssemblies.push(importedPayload);
                }
            }
        });

        importedAssembliesData.forEach((importedRow) => {
            if (importedRow[5] && importedRow[18] && importedRow[18].trim() !== '' && importedRow[18] !== '-') { // Adjusted indices: was [2,15], now [5,18]
                const assembly = importedAssemblies.find(x => x.assemblyId === importedRow[3]); // Adjusted index: was [0], now [3]
                let spareSet = importedAssemblies.find(x => x.assemblyId === importedRow[18]); // Adjusted index: was [15], now [18]
                if (!spareSet) spareSet = importedSubAssemblies.find(x => x.subAssemblyId === importedRow[18]); // Adjusted index: was [15], now [18]
                if (assembly && spareSet) {
                    assembly.spareBushingsSetId = spareSet.id;
                    assembly.spareBushingsSetQuantity = Number.parseInt(importedRow[19]);
                    assembly.spareHardwareSetId = null;
                    assembly.spareHardwareSetQuantity = Number.parseInt(importedRow[19]);
                }
            }
        });

        let confirm= window.confirm(`Are you sure you want to import ${importedAssemblies.length} assemblies and ${importedSubAssemblies.length} subassemblies?`);

        if (confirm) {
            Promise.all([self.saveAssemblies(importedAssemblies), self.saveSubAssemblies(importedSubAssemblies)]).then(() => {
                window.$alertSuccess("Assemblies imported");
                self.setState({importAssembliesOpen: false, savingImportedData: false});
                self.loadData();
            });
        } else {
            self.setState({savingImportedData: false});
        }
    };

    saveAssemblies = (assemblies) => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        return assemblyService.importAssemblies(assemblies);
    };

    saveSubAssemblies = (subAssemblies) => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        return assemblyService.importSubAssemblies(subAssemblies);
    };

    importParentChild = () => {
        const self = this;
        let {importedParentChildData} = self.state;
        if (!importedParentChildData) return window.$alertWarning("You must upload a .csv file to import.");

        self.setState({savingImportedData: true});
        let importedSubAssembliesToAssemblies = [];
        let importedSubAssembliesToSubAssemblies = [];
        let importedPartsToAssemblies = [];
        let importedPartsToSubAssemblies = [];

        let lastParent = '';
        let lastParentOrder = 0;
        importedParentChildData = importedParentChildData.slice(1);
        importedParentChildData.forEach((importedRow) => {
            if (importedRow[2]) {
                if (lastParent !== importedRow[0]) {
                    lastParent = importedRow[0];
                    lastParentOrder = 0;
                } else lastParentOrder++;

                const parentAssembly = assemblies.find(x => x.assembly.assemblyId === importedRow[0] && x.assembly.revision === importedRow[1]);
                const parentSubAssembly = subAssemblies.find(x => x.subAssembly.subAssemblyId === importedRow[0] && x.subAssembly.revision === importedRow[1]);
                const childSubAssembly = subAssemblies.find(x => x.subAssembly.subAssemblyId === importedRow[7] && x.subAssembly.revision === importedRow[8]);
                const childPart = parts.find(x => x.part.partId === importedRow[7]);

                if (parentAssembly && childSubAssembly) {
                    importedSubAssembliesToAssemblies.push({
                        id: uuid(),
                        assemblyFk: parentAssembly.assembly.id,
                        subAssemblyFk: childSubAssembly.subAssembly.id,
                        quantity: Number.parseInt(importedRow[6]),
                        requiredForBomCheck: true,
                        order: lastParentOrder
                    });
                } else if (parentAssembly && childPart) {
                    importedPartsToAssemblies.push({
                        id: uuid(),
                        assemblyFk: parentAssembly.assembly.id,
                        partFk: childPart.part.id,
                        quantity: Number.parseInt(importedRow[6]),
                        requiredForBomCheck: true,
                        order: lastParentOrder
                    });
                } else if (parentSubAssembly && childPart) {
                    importedPartsToSubAssemblies.push({
                        id: uuid(),
                        subAssemblyFk: parentSubAssembly.subAssembly.id,
                        partFk: childPart.part.id,
                        quantity: Number.parseInt(importedRow[6]),
                        requiredForBomCheck: true,
                        order: lastParentOrder
                    });
                } else if (parentSubAssembly && childSubAssembly) {
                    importedSubAssembliesToSubAssemblies.push({
                        id: uuid(),
                        parentSubAssemblyFk: parentSubAssembly.subAssembly.id,
                        childSubAssemblyFk: childSubAssembly.subAssembly.id,
                        quantity: Number.parseInt(importedRow[6]),
                        requiredForBomCheck: true,
                        order: lastParentOrder
                    });
                }
            }
        });

        let confirm= window.confirm(`Are you sure you want to import the Parent/Child relationships?`);

        if (confirm) {
            Promise.all([self.savePartsToAssemblies(importedPartsToAssemblies), self.saveSubAssembliesToSubAssemblies(importedSubAssembliesToSubAssemblies), self.saveSubAssembliesToAssemblies(importedSubAssembliesToAssemblies), self.savePartsToSubAssemblies(importedPartsToSubAssemblies)]).then(() => {
                window.$alertSuccess("Parent/Child imported");
                self.setState({importParentChildOpen: false, savingImportedData: false});
                self.loadData();
            });
        } else {
            self.setState({savingImportedData: false});
        }
    };

    savePartsToAssemblies = (parentChildren) => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        return assemblyService.importPartsToAssemblies(parentChildren);
    };

    saveSubAssembliesToAssemblies = (parentChildren) => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        return assemblyService.importSubAssembliesToAssemblies(parentChildren);
    };

    saveSubAssembliesToSubAssemblies = (parentChildren) => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        return assemblyService.importSubAssembliesToSubAssemblies(parentChildren);
    };

    savePartsToSubAssemblies = (parentChildren) => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        return assemblyService.importPartsToSubAssemblies(parentChildren);
    };

    importPackaging = () => {
        const self = this;
        let {importedPackagingData} = self.state;
        if (!importedPackagingData) return window.$alertWarning("You must upload a .csv file to import.");

        self.setState({savingImportedData: true});
        let importedLogs = [];

        importedPackagingData = importedPackagingData.slice(2);
        importedPackagingData.forEach((importedRow) => {
            if (importedRow[2]) {
                const assembly = assemblies.find(x => x.assembly.assemblyId === importedRow[2] && x.assembly.revision === importedRow[3]);
                const subAssembly = subAssemblies.find(x => x.subAssembly.subAssemblyId === importedRow[2] && x.subAssembly.revision === importedRow[3]);

                if (assembly || subAssembly) {
                    importedLogs.push({
                        id: uuid(),
                        assemblyId: assembly ? assembly.assembly.id : null,
                        subAssemblyId: subAssembly ? subAssembly.subAssembly.id : null,
                        quantity: Number.parseInt(importedRow[1]),
                        logDate: new Date(importedRow[0]),
                        reason: "Imported from Excel"
                    });
                }
            }
        });

        let confirm= window.confirm(`Are you sure you want to import?`);

        if (confirm) {
            const assemblyService = ServiceLocator.Instance.getAssemblyService();
            assemblyService.importPackagingLogs(importedLogs).then(() => {
                window.$alertSuccess("Packaging Logs imported");
                self.setState({importPackagingOpen: false, savingImportedData: false});
                self.loadData();
            });
        } else {
            self.setState({savingImportedData: false});
        }
    };

    importInventory = () => {
        const self = this;
        let {importedInventoryData} = self.state;
        if (!importedInventoryData) return window.$alertWarning("You must upload a .csv file to import.");

        self.setState({savingImportedData: true});
        let importedLogs = [];

        importedInventoryData = importedInventoryData.slice(2);
        importedInventoryData.forEach((importedRow) => {
            if (importedRow[2]) {
                const part = parts.find(x => x.part.partId === importedRow[2]);

                if (part) {
                    importedLogs.push({
                        id: uuid(),
                        partId: part.part.id,
                        quantity: Number.parseInt(importedRow[1]),
                        reason: '',
                        logDate: new Date(importedRow[0])
                    });
                }
            }
        });

        let confirm= window.confirm(`Are you sure you want to import?`);

        if (confirm) {
            const partService = ServiceLocator.Instance.getPartService();
            partService.importInventoryLogs(importedLogs).then(() => {
                window.$alertSuccess("Inventory Logs imported");
                self.setState({importInventoryOpen: false, savingImportedData: false});
                self.loadData();
            });
        } else {
            self.setState({savingImportedData: false});
        }
    };

    importSalesLogs = () => {
        const self = this;
        let {importedSalesLogsData} = self.state;
        if (!importedSalesLogsData) return window.$alertWarning("You must upload a .csv file to import.");

        self.setState({savingImportedData: true});
        let salesLogs = [];

        importedSalesLogsData = importedSalesLogsData.slice(1);
        importedSalesLogsData.forEach((importedRow) => {
            // Skip empty rows
            if (!importedRow[0] || !importedRow[1] || !importedRow[2] || !importedRow[3] || !importedRow[4]) {
                return;
            }

            const date = new Date(importedRow[0]); // Date
            const source = importedRow[1]; // Source
            const orderNumber = importedRow[2]; // Order #
            const quantity = Number.parseInt(importedRow[3]) || 0; // Qty
            const partNumber = importedRow[4]; // PN
            let revision = importedRow[5]; // Rev
            const partNumberWithRev = importedRow[6]; // PN w/Rev
            const hasProjections = importedRow[7] === 'x'; // Projections
            const projectionPN = importedRow[8]; // Projection PN
            const projectionPNWithRev = importedRow[9]; // Projection PN w/Rev

            // Handle missing or invalid revision
            if (!revision || revision === '-' || revision === '') {
                revision = null; // Will be set to highest revision
            }

            // Search for the item in parts, subassemblies, and assemblies
            let foundItem = null;
            let itemType = null;

            // Search in parts
            let foundPart = null;
            if (revision) {
                foundPart = parts.find(part => 
                    part.part.partId === partNumber && part.part.revision === revision
                );
            } else {
                // Find highest revision
                const matchingParts = parts.filter(part => part.part.partId === partNumber);
                if (matchingParts.length > 0) {
                    foundPart = matchingParts.reduce((highest, current) => {
                        const highestRev = parseInt(highest.part.revision) || 0;
                        const currentRev = parseInt(current.part.revision) || 0;
                        return currentRev > highestRev ? current : highest;
                    });
                }
            }
            if (foundPart) {
                foundItem = foundPart;
                itemType = 'part';
            }

            // Search in subassemblies
            if (!foundItem) {
                let foundSubAssembly = null;
                if (revision) {
                    foundSubAssembly = subAssemblies.find(subAssembly => 
                        subAssembly.subAssembly.subAssemblyId === partNumber && subAssembly.subAssembly.revision === revision
                    );
                } else {
                    // Find highest revision
                    const matchingSubAssemblies = subAssemblies.filter(subAssembly => 
                        subAssembly.subAssembly.subAssemblyId === partNumber
                    );
                    if (matchingSubAssemblies.length > 0) {
                        foundSubAssembly = matchingSubAssemblies.reduce((highest, current) => {
                            const highestRev = parseInt(highest.subAssembly.revision) || 0;
                            const currentRev = parseInt(current.subAssembly.revision) || 0;
                            return currentRev > highestRev ? current : highest;
                        });
                    }
                }
                if (foundSubAssembly) {
                    foundItem = foundSubAssembly;
                    itemType = 'subassembly';
                }
            }

            // Search in assemblies
            if (!foundItem) {
                let foundAssembly = null;
                if (revision) {
                    foundAssembly = assemblies.find(assembly => 
                        assembly.assembly.assemblyId === partNumber && assembly.assembly.revision === revision
                    );
                } else {
                    // Find highest revision
                    const matchingAssemblies = assemblies.filter(assembly => 
                        assembly.assembly.assemblyId === partNumber
                    );
                    if (matchingAssemblies.length > 0) {
                        foundAssembly = matchingAssemblies.reduce((highest, current) => {
                            const highestRev = parseInt(highest.assembly.revision) || 0;
                            const currentRev = parseInt(current.assembly.revision) || 0;
                            return currentRev > highestRev ? current : highest;
                        });
                    }
                }
                if (foundAssembly) {
                    foundItem = foundAssembly;
                    itemType = 'assembly';
                }
            }

            if (foundItem) {
                // Fast duplicate check using Set lookup
                const dateStr = date.toDateString();
                let itemId = '';
                
                if (itemType === 'part' && foundItem.part && foundItem.part.id) {
                    itemId = foundItem.part.id;
                } else if (itemType === 'subassembly' && foundItem.subAssembly && foundItem.subAssembly.id) {
                    itemId = foundItem.subAssembly.id;
                } else if (itemType === 'assembly' && foundItem.assembly && foundItem.assembly.id) {
                    itemId = foundItem.assembly.id;
                }

                const salesLog = {
                    id: uuid(),
                    logDate: date,
                    source: source,
                    orderNumber: orderNumber,
                    quantity: quantity,
                    userId: AuthenticationService.getInstance().getUserId(),
                    partId: null,
                    subAssemblyId: null,
                    assemblyId: null,
                    reason: 'Imported from Excel',
                    affectsProjections: hasProjections,
                    status: 'Fulfilled' // Default to "Fulfilled" for legacy imports
                };

                // Set the appropriate ID based on item type
                if (itemType === 'part') {
                    salesLog.partId = foundItem.part.id;
                } else if (itemType === 'subassembly') {
                    salesLog.subAssemblyId = foundItem.subAssembly.id;
                } else if (itemType === 'assembly') {
                    salesLog.assemblyId = foundItem.assembly.id;
                }

                salesLogs.push(salesLog);
            } else {
                console.warn(`Item not found: ${partNumber} rev ${revision}`);
            }
        });

        if (salesLogs.length === 0) {
            window.$alertWarning("No valid sales logs found to import.");
            self.setState({savingImportedData: false});
            return;
        }

        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        assemblyService.importSalesLogs(salesLogs).then(() => {
            window.$alertSuccess(`${salesLogs.length} sales logs imported successfully`);
            self.setState({importSalesLogsOpen: false, savingImportedData: false});
            self.loadData();
        }).catch((error) => {
            console.error('Error importing sales logs:', error);
            window.$alertError("Failed to import sales logs");
            self.setState({savingImportedData: false});
        });
    };

    importPurchases = () => {
        const self = this;
        let {importedPurchasesData} = self.state;
        if (!importedPurchasesData) return window.$alertWarning("You must upload a .csv file to import.");

        self.setState({savingImportedData: true});
        
        // Skip header row and filter out empty rows
        importedPurchasesData = importedPurchasesData.slice(1).filter(row => row[0] && row[1] && row[3]);

        // Group rows by Order Date and Company
        const orderGroups = {};
        importedPurchasesData.forEach((importedRow) => {
            const orderDate = importedRow[0];
            const company = importedRow[1];
            const groupKey = `${orderDate}-${company}`;
            
            if (!orderGroups[groupKey]) {
                orderGroups[groupKey] = {
                    orderDate: new Date(orderDate),
                    company: company,
                    rows: []
                };
            }
            orderGroups[groupKey].rows.push(importedRow);
        });

        // Check if orders are after cutoff date (2025-06-04)
        const cutoffDate = new Date('2025-06-04');
        
        const promises = Object.values(orderGroups).map(async (group) => {
            const isAfterCutoff = group.orderDate >= cutoffDate;
            
            // Create purchase order
            const purchaseOrderId = uuid();
            const purchasedParts = [];
            
            for (const row of group.rows) {
                // Search for the item in parts, subassemblies, and assemblies
                let foundItem = null;
                let itemType = null;

                // Search in parts
                let foundPart = parts.find(x => x.part.partId === row[3]);
                if (foundPart) {
                    foundItem = foundPart;
                    itemType = 'part';
                }

                // Search in subassemblies
                if (!foundItem) {
                    let foundSubAssembly = subAssemblies.find(x => x.subAssembly.subAssemblyId === row[3]);
                    if (foundSubAssembly) {
                        foundItem = foundSubAssembly;
                        itemType = 'subassembly';
                    }
                }

                // Search in assemblies with "currently selling" logic
                if (!foundItem) {
                    const matchingAssemblies = assemblies.filter(x => x.assembly.assemblyId === row[3]);
                    if (matchingAssemblies.length > 0) {
                        // Prioritize currently selling assemblies (no finalOrderNumber)
                        const currentlySelling = matchingAssemblies.filter(x => !x.assembly.finalOrderNumber);
                        if (currentlySelling.length > 0) {
                            // Among currently selling, get highest revision
                            foundItem = currentlySelling.sort((a, b) => b.assembly.revision - a.assembly.revision)[0];
                        } else {
                            // If none currently selling, get highest revision
                            foundItem = matchingAssemblies.sort((a, b) => b.assembly.revision - a.assembly.revision)[0];
                        }
                        itemType = 'assembly';
                    }
                }

                if (!foundItem) {
                    console.warn(`Item not found: ${row[3]}`);
                    continue;
                }

                const quantity = Number.parseInt(row[2]) || 0;
                let unitCost = 0.00;
                try {
                    unitCost = row[5] ? Number.parseFloat(row[5].toString().replace('$', '').trim()) : 0.00;
                    if (isNaN(unitCost) || !isFinite(unitCost)) {
                        unitCost = 0.00;
                    }
                    // Ensure it's a decimal
                    unitCost = parseFloat(unitCost.toFixed(2)) || 0.00;
                } catch (e) {
                    unitCost = 0.00;
                }
                const qtyReceived = (row[7] && row[7].toString().trim() !== '' ? Number.parseInt(row[7]) : 0) ?? 0;
                const isPaid = row[11] === 'x';
                const recDate = row[12] && row[12].toString().trim() !== '' ? new Date(row[12]) : null;

                // Get the appropriate item and lead time based on item type
                let itemId = null;
                let leadTimeWeeks = 0;
                
                if (itemType === 'part') {
                    itemId = foundItem.part.id;
                    leadTimeWeeks = foundItem.part.leadTimeInWeeks || 0;
                } else if (itemType === 'subassembly') {
                    itemId = foundItem.subAssembly.id;
                    leadTimeWeeks = foundItem.subAssembly.leadTimeInWeeks || 0;
                } else if (itemType === 'assembly') {
                    itemId = foundItem.assembly.id;
                    leadTimeWeeks = foundItem.assembly.leadTimeInWeeks || 0;
                }

                // Calculate effective date for invoice/packing slip
                let effectiveDate;
                if (recDate) {
                    effectiveDate = recDate;
                } else {
                    // Use order date + lead time
                    effectiveDate = new Date(group.orderDate);
                    effectiveDate.setDate(effectiveDate.getDate() + (leadTimeWeeks * 7));
                }

                purchasedParts.push({
                    id: uuid(),
                    partId: itemId,
                    companyName: group.company,
                    quantity: quantity,
                    quantityReceived: 0, // Will be updated by packing slip receipt
                    isPaid: false, // Will be updated by invoice
                    isReceived: false, // Will be updated by packing slip receipt
                    orderDate: group.orderDate,
                    receivedDate: null, // Will be updated by packing slip receipt
                    pricePaid: parseFloat((unitCost * quantity).toFixed(2)) || 0.00,
                    userId: AuthenticationService.getInstance().getUserId(),
                    // Store additional data for processing
                    _originalQtyReceived: qtyReceived,
                    _originalIsPaid: isPaid,
                    _effectiveDate: effectiveDate
                });
            }

            // Skip this group if no valid purchased parts were found
            if (purchasedParts.length === 0) {
                console.warn(`No valid parts found for group: ${group.company} - ${group.orderDate}`);
                return;
            }

            let pricePaid = purchasedParts.reduce((sum, part) => sum + (parseFloat(part.pricePaid) || 0), 0);
            if (!pricePaid || isNaN(pricePaid)) {
                pricePaid = 0.00;
            }

            const purchaseOrderPayload = {
                id: purchaseOrderId,
                placedOn: group.orderDate,
                vendorOrderNumber: '', // Could be enhanced to extract from data
                pricePaid: parseFloat(pricePaid.toFixed(2)) || 0.00,
                invoices: [],
                packingSlips: [],
                userId: AuthenticationService.getInstance().getUserId(),
                purchasedParts: purchasedParts
            };

            const partService = ServiceLocator.Instance.getPartService();
            
            // Create purchase order
            const createdOrder = await partService.createPurchaseOrder(purchaseOrderPayload);
            
            // If order is after cutoff date, stop here
            if (isAfterCutoff) {
                return;
            }

            // Create invoices for paid items
            const paidParts = purchasedParts.filter(part => part._originalIsPaid);
            if (paidParts.length > 0) {
                const invoicePayload = {
                    id: uuid(),
                    invoiceNumber: `AUTO-${group.company}-${group.orderDate.toISOString().split('T')[0]}`,
                    isPaid: true,
                    userId: AuthenticationService.getInstance().getUserId(),
                    dateCreated: paidParts[0]._effectiveDate
                };

                // Create invoice
                await partService.createInvoice(invoicePayload, null);

                // Attach invoice to purchased parts with full quantities
                const invoiceQuantities = {};
                paidParts.forEach(part => {
                    invoiceQuantities[part.id] = part.quantity; // Use full ordered quantity
                });
                await partService.bulkAttachInvoiceToPurchasedParts(invoicePayload.id, invoiceQuantities);
            }

            // Create packing slips for received items
            const receivedParts = purchasedParts.filter(part => part._originalQtyReceived > 0);
            if (receivedParts.length > 0) {
                const packingSlipPayload = {
                    id: uuid(),
                    name: `AUTO-${group.company}-${group.orderDate.toISOString().split('T')[0]}`,
                    trackingNumber: null,
                    vendorName: group.company,
                    dateCreated: receivedParts[0]._effectiveDate,
                    isReceived: false, // Will be received immediately after creation
                    userId: AuthenticationService.getInstance().getUserId(),
                    purchaseOrderFk: purchaseOrderId,
                    items: receivedParts.map(part => ({
                        id: uuid(),
                        purchasedPartId: part.id,
                        quantityExpected: part.quantity, // Use full ordered quantity
                        quantityReceived: 0 // Will be updated during receipt
                    }))
                };

                // Create packing slip
                const formData = new FormData();
                formData.append('packingSlip', JSON.stringify(packingSlipPayload));
                
                const createdPackingSlip = await partService.createPurchaseOrderPackingSlip(formData);

                // Receive the packing slip with actual received quantities
                // Create a mapping of packing slip item IDs to quantities received
                const receivedQuantities = {};
                
                // We need to get the created packing slip items to map quantities correctly
                const createdPackingSlipData = await partService.getPurchaseOrderPackingSlipById(createdPackingSlip.id);
                
                createdPackingSlipData.items.forEach(item => {
                    // Find the corresponding purchased part to get the received quantity
                    const correspondingPart = receivedParts.find(part => part.id === item.purchasedPartId);
                    if (correspondingPart) {
                        receivedQuantities[item.id] = correspondingPart._originalQtyReceived;
                    }
                });

                await partService.receivePackingSlipWithQuantities(createdPackingSlip.id, receivedQuantities, AuthenticationService.getInstance().getUserId());
            }
        });

        let confirm = window.confirm(`Are you sure you want to import ${Object.keys(orderGroups).length} purchase orders?`);

        if (confirm) {
            Promise.all(promises).then(() => {
                window.$alertSuccess("Purchase Orders imported successfully");
                self.setState({importPurchasesOpen: false, savingImportedData: false});
                self.loadData();
            }).catch((error) => {
                console.error('Error importing purchase orders:', error);
                window.$alertError("Failed to import purchase orders");
                self.setState({savingImportedData: false});
            });
        } else {
            self.setState({savingImportedData: false});
        }
    };

    render() {
        const self = this;
        if (this.state.loading) {
            return (
                <DashboardTemplate title="Import Utilities" onSyncDatabase={this.loadData}>
                    <div className="main-dashboard-root">
                        <CircularProgress/>
                    </div>
                </DashboardTemplate>
            );
        }

        return (
            <DashboardTemplate title="Import Utilities" onSyncDatabase={this.loadData}>
                <div className="main-dashboard-root">
                    <div className="container">
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => {this.setState({importPartsOpen: true})}}
                            className="success-button-lg"
                        >
                            Import Parts
                        </Button>
                        <br /><br />
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => {this.setState({importAssembliesOpen: true})}}
                            className="success-button-lg"
                        >
                            Import Assemblies
                        </Button>
                        <br /><br />
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => {this.setState({importParentChildOpen: true})}}
                            className="success-button-lg"
                        >
                            Import Parent/Child
                        </Button>
                        <br /><br />
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => {this.setState({importPackagingOpen: true})}}
                            className="success-button-lg"
                        >
                            Import Packaging
                        </Button>
                        <br /><br />
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => {this.setState({importInventoryOpen: true})}}
                            className="success-button-lg"
                        >
                            Import Inventory
                        </Button>
                        <br /><br />
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => {this.setState({importPurchasesOpen: true})}}
                            className="success-button-lg"
                        >
                            Import Purchases
                        </Button>
                        <br /><br />
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => {this.setState({importSalesLogsOpen: true})}}
                            className="success-button-lg"
                        >
                            Import Sales Logs
                        </Button>
                        <br /><br />
                        {this.state.importPartsOpen ?
                            <DrawerMenuRight title={"Import Parts"} customWidth={800}
                                             open={this.state.importPartsOpen}
                                             onClose={() => {this.setState({importPartsOpen: false})}}>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) => {
                                        const files = e.target.files;
                                        if (files) {
                                            Papa.parse(files[0], {
                                                complete: function (results) {
                                                    self.setState({importedPartsData: results.data});
                                                }
                                            })
                                        }
                                    }}
                                />
                                <br />
                                <br />
                                {
                                    this.state.savingImportedData === true ?
                                        <CircularProgress/>
                                        :
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            onClick={this.importParts}
                                            className="success-button-lg"
                                        >
                                            Save
                                        </Button>
                                }
                            </DrawerMenuRight>
                            : ""}
                        {this.state.importAssembliesOpen ?
                            <DrawerMenuRight title={"Import Assemblies"} customWidth={800}
                                             open={this.state.importAssembliesOpen}
                                             onClose={() => {this.setState({importAssembliesOpen: false})}}>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) => {
                                        const files = e.target.files;
                                        if (files) {
                                            Papa.parse(files[0], {
                                                complete: function (results) {
                                                    self.setState({importedAssembliesData: results.data});
                                                }
                                            })
                                        }
                                    }}
                                />
                                <br />
                                <br />
                                {
                                    this.state.savingImportedData === true ?
                                        <CircularProgress/>
                                        :
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            onClick={this.importAssemblies}
                                            className="success-button-lg"
                                        >
                                            Save
                                        </Button>
                                }
                            </DrawerMenuRight>
                            : ""}
                        {this.state.importParentChildOpen ?
                            <DrawerMenuRight title={"Import Parent/Child"} customWidth={800}
                                             open={this.state.importParentChildOpen}
                                             onClose={() => {this.setState({importParentChildOpen: false})}}>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) => {
                                        const files = e.target.files;
                                        if (files) {
                                            Papa.parse(files[0], {
                                                complete: function (results) {
                                                    self.setState({importedParentChildData: results.data});
                                                }
                                            })
                                        }
                                    }}
                                />
                                <br />
                                <br />
                                {
                                    this.state.savingImportedData === true ?
                                        <CircularProgress/>
                                        :
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            onClick={this.importParentChild}
                                            className="success-button-lg"
                                        >
                                            Save
                                        </Button>
                                }
                            </DrawerMenuRight>
                            : ""}
                        {this.state.importPackagingOpen ?
                            <DrawerMenuRight title={"Import Packaging Logs"} customWidth={800}
                                             open={this.state.importPackagingOpen}
                                             onClose={() => {this.setState({importPackagingOpen: false})}}>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) => {
                                        const files = e.target.files;
                                        if (files) {
                                            Papa.parse(files[0], {
                                                complete: function (results) {
                                                    self.setState({importedPackagingData: results.data});
                                                }
                                            })
                                        }
                                    }}
                                />
                                <br />
                                <br />
                                {
                                    this.state.savingImportedData === true ?
                                        <CircularProgress/>
                                        :
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            onClick={this.importPackaging}
                                            className="success-button-lg"
                                        >
                                            Save
                                        </Button>
                                }
                            </DrawerMenuRight>
                            : ""}
                        {this.state.importInventoryOpen ?
                            <DrawerMenuRight title={"Import Inventory Logs"} customWidth={800}
                                             open={this.state.importInventoryOpen}
                                             onClose={() => {this.setState({importInventoryOpen: false})}}>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) => {
                                        const files = e.target.files;
                                        if (files) {
                                            Papa.parse(files[0], {
                                                complete: function (results) {
                                                    self.setState({importedInventoryData: results.data});
                                                }
                                            })
                                        }
                                    }}
                                />
                                <br />
                                <br />
                                {
                                    this.state.savingImportedData === true ?
                                        <CircularProgress/>
                                        :
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            onClick={this.importInventory}
                                            className="success-button-lg"
                                        >
                                            Save
                                        </Button>
                                }
                            </DrawerMenuRight>
                            : ""}
                        {this.state.importPurchasesOpen ?
                            <DrawerMenuRight title={"Import Purchase Logs"} customWidth={800}
                                             open={this.state.importPurchasesOpen}
                                             onClose={() => {this.setState({importPurchasesOpen: false})}}>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) => {
                                        const files = e.target.files;
                                        if (files) {
                                            Papa.parse(files[0], {
                                                complete: function (results) {
                                                    self.setState({importedPurchasesData: results.data});
                                                }
                                            })
                                        }
                                    }}
                                />
                                <br />
                                <br />
                                {
                                    this.state.savingImportedData === true ?
                                        <CircularProgress/>
                                        :
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            onClick={this.importPurchases}
                                            className="success-button-lg"
                                        >
                                            Save
                                        </Button>
                                }
                            </DrawerMenuRight>
                            : ""}
                        {this.state.importSalesLogsOpen ?
                            <DrawerMenuRight title={"Import Sales Logs"} customWidth={800}
                                             open={this.state.importSalesLogsOpen}
                                             onClose={() => {this.setState({importSalesLogsOpen: false})}}>
                                <input
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) => {
                                        const files = e.target.files;
                                        if (files) {
                                            Papa.parse(files[0], {
                                                complete: function (results) {
                                                    self.setState({importedSalesLogsData: results.data});
                                                }
                                            })
                                        }
                                    }}
                                />
                                <br />
                                <br />
                                {
                                    this.state.savingImportedData === true ?
                                        <CircularProgress/>
                                        :
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            onClick={this.importSalesLogs}
                                            className="success-button-lg"
                                        >
                                            Save
                                        </Button>
                                }
                            </DrawerMenuRight>
                            : ""}
                    </div>
                </div>
            </DashboardTemplate>
        );
    }
}

let globalProps;

AdminImportUtilities.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminImportUtilities);
